import { IconButton, MenuItem, Menu, Fade } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import React, { useState, useMemo } from 'react';
import { StyledButtonPopover } from './buttonPopover.style';

export interface IButtonPopoverProps {
  options: {
    key: string;
    label: string;
    id?: string;
    icon?: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
  }[];
  icon?: React.ReactNode;
};

const ButtonPopover = (props: IButtonPopoverProps) => {
  const { options, icon } = props;
  const enabledOptions = options.filter(((option) => !option.disabled));

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = useMemo(() => Boolean(anchorEl), [anchorEl]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onClickItem = (item: any) => {
    handleClose();
    item.onClick();
  };

  return (
    <>
      <StyledButtonPopover>
        <IconButton
          id="button-toggle-popover"
          aria-label="more"
          aria-controls="fade-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          {icon}
        </IconButton>
        <Menu
          id="fade-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
          disableScrollLock
        >
          {enabledOptions.map((item) => (
            <MenuItem key={item.key} id={item.id} onClick={() => onClickItem(item)}>
              {item.icon}
              {item.label}
            </MenuItem>
          ))}
        </Menu>

      </StyledButtonPopover>
    </>
  )
};

export const defaultProps: IButtonPopoverProps = {
  options: [
    {
      key: "1",
      label: 'Option 1',
      onClick: () => console.log('Option 1')
    },
    {
      key: "2",
      label: 'Option 2',
      onClick: () => console.log('Option 2')
    }
  ],
  icon: <MoreHoriz fontSize='small' />
};

ButtonPopover.defaultProps = defaultProps;

export default ButtonPopover